module.exports = __webpack_public_path__ + "img/icon_heart_red.44966d89.svg";